import React from "react"

import { RecentPosts } from "../blog/recentPosts"
import { StandardBlockWrapper } from "./standardBlockWrapper"

const RecentPostsBlock = ({ heading, backgroundColor, padding }) => {
  return (
    <StandardBlockWrapper
      padding={padding}
      backgroundColor={backgroundColor}
      className="grid grid-cols-14"
    >
      <h2 className="font-display text-4xl text-center col-span-full">
        {heading}
      </h2>
      <div className="col-start-2 col-end-14 lg:col-start-3 lg:col-end-13">
        <RecentPosts />
      </div>
    </StandardBlockWrapper>
  )
}

export default RecentPostsBlock
